import React, {useState, useEffect} from 'react';
import {GiHamburgerMenu} from "react-icons/gi";
import {Container, Col, Row} from "react-bootstrap";
import {Link, NavLink, useNavigate} from "react-router-dom";
import CustomButton from "../../components/accesories/customBtn/CustomButton";
import {SlHandbag} from "react-icons/sl";
import './header.css';
import useHandleRequest from '../../custom_hooks/useHandleRequest';


import Collapse from "./components/Collapse";
import {useLoadingBar} from "../../context/LoadingBarContext";
import {toast} from "react-toastify";

function Header(props) {
    const [showNavbar, setShowNavbar] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false);
    const [inputValue, setInputValue] = useState("")
    const navigate = useNavigate();

    const searchButtonClicked = () => {
        if (inputValue.trim().length > 3) {
            navigate(`/blogs/search/?search=${inputValue}`)
        } else {
            toast.warn('برای جست‌وجو باید بیش از سه کارکتر وارد نمایید')
        }
    }

    const closeNavBar = () => {
        setShowNavbar(false)
    }

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) { // مقدار مشخص برای اسکرول
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // پاک‌سازی رویداد هنگام حذف کامپوننت
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const {handleRequestAndNavigate} = useHandleRequest();


    return (
        <div className={`container-fluid header-container ${isScrolled ? 'fixed-header' : ''}`}>
            <Container className={''}>
                <Row className={''}>
                    <Col>
                        <div className={'nav-items-wrapper'}>
                            <div className="header-right-side">
                                <Link to={'/'}>
                                    <img src="/static/images/img.png" alt=""/>
                                </Link>
                                <button className={'burger-btn'} onClick={() => setShowNavbar(prev => !prev)}>
                                    <GiHamburgerMenu/>
                                </button>
                                <div className="header-middle-side">
                                    <ul>
                                        <li className="nav-item dropdown"><NavLink to={'/'}
                                                                                   className={'nav-link'}
                                                                                   onClick={(e) => handleRequestAndNavigate(e, '/', '/', 'home')}
                                        >خانه</NavLink>
                                        </li>
                                        <li className="nav-item dropdown"><NavLink to={'/events'}
                                                                                   className={'nav-link'}
                                                                                   c
                                        >رویدادها</NavLink>
                                        </li>
                                        <li className="nav-item dropdown"><NavLink to={'/projects'}
                                                                                   className={'nav-link'}
                                                                                   onClick={(e) => handleRequestAndNavigate(e, '/projects', 'projects/', 'projects')}
                                        >پروژه‌ها</NavLink>
                                        </li>
                                        <li className="nav-item dropdown"><NavLink to={'/blogs'}
                                                                                   className={'nav-link'}
                                                                                   onClick={(e) => handleRequestAndNavigate(e, '/blogs', 'blogs/', 'blogs')}
                                        >بلاگ</NavLink>
                                        </li>
                                        <li className="nav-item dropdown"><NavLink to={'/faq'}
                                                                                   className={'nav-link'}
                                                                                   onClick={(e) => handleRequestAndNavigate(e, '/faq', 'faq/', 'faq')}
                                        >پرسش‌های
                                            متداول</NavLink>
                                        </li>
                                        <li className="nav-item dropdown"><NavLink
                                            onClick={(e) => handleRequestAndNavigate(e, '/about-us', 'about-us/', 'about_us')}
                                            to={'/about-us'}
                                            className={'nav-link'}>درباره
                                            ما</NavLink>
                                        </li>
                                        <li className="nav-item dropdown"><NavLink
                                            onClick={(e) => handleRequestAndNavigate(e, '/contact-us', 'contact-us/', 'contact_us')}
                                            to={'/contact-us'}
                                            className={'nav-link'}>تماس با
                                            ما</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className={'header-left-side'}>
                                <div className={'search-box'}>
                                    <input type="text" placeholder={'جست و جو ...'}
                                           onChange={e => setInputValue(e.target.value)}
                                           onKeyDown={e => {
                                               if (e.key === 'Enter') {
                                                   searchButtonClicked();
                                               }
                                           }}
                                    />
                                    {/*<span><i className="fa-solid fa-magnifying-glass"></i></span>*/}
                                    <CustomButton buttonClicked={searchButtonClicked} height={'100%'} width={'3rem'}
                                                  icon={<i
                                                      className="fa-solid fa-magnifying-glass"></i>}/>

                                </div>
                                <CustomButton
                                    buttonClicked={()=>{toast.warn('برای ورود به قسمت کاربری لطفا با پشتیبانی تماس بگیرید')}}
                                    icon={<i className="fa-regular fa-user"></i>}
                                    text={'ورود'} height={'3rem'}
                                />
                                {/*آیکون سبد خرید*/}
                                {/*<Link to={'/cart'} className={'cart-wrapper'}>
                                    <span className={'cart-counter'}>1</span>
                                    <SlHandbag className={'cart-link'}/>
                                </Link>*/}
                            </div>

                            <Collapse closeNavbar={closeNavBar} showNavbar={showNavbar}/>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>

    );
}

export default Header;